import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService } from '../../../shared/services/appsettings.service';

@Injectable()
export class ContestService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization',
        'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE'
      }
    )
  };

  constructor(private http: HttpClient) {
  }

  getWinners(year) {
    return this.http
      .get(AppSettingsService.settings.dartArtGalleryApiUrl + 'api/contest/' + year + '/result',
        this.httpOptions);
  }

  getContestOpenForVote() {
    return this.http
      .get(AppSettingsService.settings.dartArtGalleryApiUrl + 'api/contest/vote',
        this.httpOptions);
  }
}
